import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.204 15.48-.381.178v6.082l1.593-.796a.622.622 0 0 1 .837.279.624.624 0 0 1-.279.837l-2.496 1.248a.626.626 0 0 1-.316.065.625.625 0 0 1-.587-.623v-7.102l-7.882-3.911a1.248 1.248 0 0 1 .362-2.351l21.341-3.348a3.12 3.12 0 0 1 3.283 4.46l-6.563 14.71a1.248 1.248 0 0 1-2.09.216l-7.203-8.466v-1.3l.381-.178 7.78 9.144 6.568-14.662a1.872 1.872 0 0 0-1.962-2.691L4.248 10.619l7.959 3.95 12.225-5.726a.622.622 0 0 1 .83.3.624.624 0 0 1-.3.83L13.203 15.48Z",
    fill: "currentColor"
  }));
};

var SvgSend = styled(SvgComponent).withConfig({
  displayName: "Send__SvgSend",
  componentId: "sc-13qrd3h-0"
})(["", " ", ""], size, color);
export default SvgSend;